
import { assessmentHasImagesOrComments } from '@/shared/helpers';
import globalConstants from '../../shared/globalConstants';
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import TrailerAssessment from '../../types/TrailerAssessment';
import TrailerAssessmentType from '../../types/TrailerAssessmentType';
import TrailerDamageLayout from './TrailerDamageLayout.vue';

export default defineComponent({
    components: { TrailerDamageLayout },
    data(): {
        type: keyof TrailerAssessment;
        subTypes: {
            driverSide: string;
            passengerSide: string;
        };
        typeAssessment: TrailerAssessmentType | undefined;
    } {
        return {
            type: globalConstants.trailer.assessmentTypes
                .tires as keyof TrailerAssessment,
            subTypes: {
                driverSide:
                    globalConstants.trailer.assessmentTypes.subTypes.driverSide,
                passengerSide:
                    globalConstants.trailer.assessmentTypes.subTypes
                        .passengerSide,
            },
            typeAssessment: undefined,
        };
    },
    created() {
        if (this.trailerAssessment)
            this.typeAssessment = this.trailerAssessment[this.type];
    },
    computed: {
        ...mapGetters({ trailerAssessment: 'trailerAssessment' }),
        driverSide(): string {
            return assessmentHasImagesOrComments(
                this.typeAssessment as TrailerAssessmentType,
                this.subTypes.driverSide
            )
                ? 'active'
                : '';
        },
        passengerSide(): string {
            return assessmentHasImagesOrComments(
                this.typeAssessment as TrailerAssessmentType,
                this.subTypes.passengerSide
            )
                ? 'active'
                : '';
        },
    },
    methods: {
        enterDriverSide(): void {
            this.$router.push({
                path: `tiresAssessment/${this.subTypes.driverSide}`,
            });
        },
        enterPassengerSide(): void {
            this.$router.push({
                path: `tiresAssessment/${this.subTypes.passengerSide}`,
            });
        },
    },
});
